import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=de30e1ca&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
